import {
  Box,
  Divider,
  Link,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import useAxios from "../hooks/useAxios";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  useNavigate,
  // Link as RouterLink,
  // useLocation,
  useSearchParams,
} from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { subscribe } from "../config/axios";
import PoweredBy from "../components/layout/PoweredBy";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const axios = useAxios();
  const navigate = useNavigate();
  // const { pathname } = useLocation();
  // const pathArray = pathname.split("/");
  const [searchParams] = useSearchParams();
  const zainPhone = searchParams.get("msisdn");
  const { saveToken, savePhoneNumber } = useAuth();

  const login = async ({ phoneNumber }) => {
    setSubmitted(true);
    setLoading(true);
    try {
      const body = { phoneNumber: phoneNumber };

      const response = await axios.post("auth", body);
      // console.log(response.data);
      saveToken(response?.data?.accessToken);
      savePhoneNumber(phoneNumber);
      navigate("/");
    } catch (error) {}
    setLoading(false);
  };

  const formik = useFormik({
    initialValues: {
      phoneNumber: zainPhone ?? "",
    },
    validationSchema: yup.object({
      phoneNumber: yup
        .string()
        .required("الرجاء إدخال رقم الهاتف")
        .matches(
          /^([0-9]{9})$|^([0-9]{10})$|^([0-9]{12})$/,
          // /^([0-9]{3})[\s]?([0-9]{3})[\s]?([0-9]{4})$/

          "الرجاء إدخال رقم هاتف صحيح"
        ),
    }),
    onSubmit: login,
  });

  useEffect(() => {
    !submitted && zainPhone && formik.submitForm();
  }, [submitted, formik, zainPhone]);
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      alignContent="center"
      textAlign="center"
      minHeight="100vh"
      px={4}
      sx={{
        backgroundColor: "#f9f9f9",
        opacity: 0.8,
        backgroundImage:
          "radial-gradient(#45A247 1.7000000000000002px, transparent 1.7000000000000002px), radial-gradient(#45A247 1.7000000000000002px, #f9f9f9 1.7000000000000002px)",
        backgroundSize: "68px 68px",
        backgroundPosition: "0 0,34px 34px",
      }}
    >
      <Stack width={{ md: "60%", lg: "40%" }} minHeight="100dvh">
        <Box component="form" mt="auto" onSubmit={formik.handleSubmit}>
          <Stack bgcolor="white" px={5} py={7} borderRadius={3} boxShadow={3}>
            <Typography
              variant="h3"
              fontWeight={700}
              mb={3}
              onClick={() => navigate("/")}
              sx={{ cursor: "pointer" }}
            >
              قانوني
            </Typography>
            <Typography>سجل الدخول الآن برقم هاتف زين الخاص بك!</Typography>
            <Divider sx={{ my: 4 }} />
            <TextField
              dir="auto"
              id="phoneNumber"
              name="phoneNumber"
              size="small"
              variant="outlined"
              sx={{ mb: 2, mt: 1 }}
              placeholder="رقم الهاتف"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)
              }
              helperText={
                formik.touched.phoneNumber && formik.errors.phoneNumber
              }
            />
            <LoadingButton loading={loading} variant="contained" type="submit">
              تسجيل الدخول
            </LoadingButton>
            <Link
              // component={RouterLink}
              // to="/subscribe"
              href={subscribe}
              mt={1}
              mb={2}
              mx={1}
              fontSize="0.8rem"
              alignSelf="flex-start"
            >
              لست مشتركا ، اشترك الآن!
            </Link>
            <Typography variant="caption" fontSize="0.6rem" mt={1} mx={1}>
              قيمة الاشتراك اليومي لكل المقاطع والبرامج شاملة الضريبة تجدد
              تلقائيا عبر شبكة زين
            </Typography>
          </Stack>
        </Box>
        <PoweredBy />
      </Stack>
    </Stack>
  );
}
